import React from 'react';
import { Box } from 'grommet';
import { JobReporting } from './JobReporting';
import { PipelineReporting } from './PipelineReporting';
import { SchoolReporting } from './SchoolReporting';

export const ExternalReporting = () => {
    return (
        <Box pad={{ top: 'small' }}>
            <JobReporting />
            <PipelineReporting />
            <SchoolReporting />
        </Box>
    );
};

export async function loader() {
    return {};
}
